import { api } from "@/api";
import { AddLeagueNewParams, LeagueDto } from "@/types/ApiResponses/League";

export const addLeagueNew = async (
  params: AddLeagueNewParams
): Promise<LeagueDto> => {
  const res = await api.client.post(`/leagues-new`, params);
  return res.data;
};
